import type { TelegramWhiteLabelResponse } from '@/generated/types/TelegramWhiteLabelResponse';

const haveRequestedPhoneNumberOnStartKey = 'haveRequestedPhoneNumberOnStart';

export function shouldRequestPhoneNumberOnStart(
  isEnabled: TelegramWhiteLabelResponse['isPhoneRequestOnStartEnabled'] | undefined,
  hasPhoneNumber: boolean,
  storage: Pick<Storage, 'getItem' | 'setItem'>,
) {
  if (isEnabled !== true || hasPhoneNumber) {
    return false;
  }

  if (storage.getItem(haveRequestedPhoneNumberOnStartKey) === 'true') {
    return false;
  }

  storage.setItem(haveRequestedPhoneNumberOnStartKey, 'true');
  return true;
}
